import { ModalLink as ModalLinkType } from '@/schemas/sceneDataSchema';
import { Link } from '@mui/material';
import useModal from '@/hooks/use-modals';

export const ModalLink = ({ component }: { component: ModalLinkType }) => {
  const { getModal } = useModal();
  const modal = getModal(component.modal_id);

  const onClick = () => {
    if (modal === undefined) {
      return;
    }
    if (component.method_type === 'open') {
      modal?.open();
    } else if (component.method_type === 'close') {
      modal.close();
    } else if (component.method_type === 'toggle') {
      modal.toggle();
    }
  };

  return (
    <Link
      onClick={onClick}
      color={component.color}
      align={component.align}
      variant={component.variant}
      fontWeight={component.font_weight ?? undefined}
    >
      {component.text}
    </Link>
  );
};
